import { Injectable }    from '@angular/core';
import { Observable }    from 'rxjs/Observable';
import { ApiService }    from '../../root-services/api.service';

import { FieldManual } from './../../models/program/field-manual';

@Injectable()
export class FieldManualService {
  private programsUrl = '/programs';
  _parentID: number;
  _fms: Observable<FieldManual[]> = null;

  constructor(private api: ApiService) { }

  public getFieldManuals(id: number): Observable<FieldManual[]> {
    if (id !== this._parentID) {
      this._parentID = id;

      this._fms = this.api.get(`${this.programsUrl}/${id}/fms`)
                      .map(response => response.json() as FieldManual[])
                      .publishReplay(1).refCount()
                      .catch(this.handleError);
    }

    return this._fms;
  }

  public getFieldManual(id: number): Observable<FieldManual> {
    return this._fms.map(fms => fms.find(fm => fm.id === id));
  }

  public addFieldManual(id: number, fm: FieldManual): Promise<FieldManual> {

    return this.api.post(`${this.programsUrl}/${id}/fms`, fm)
                   .toPromise()
                   .then(response => response.json())
                   .catch(this.handleError);
  }

  public reorderFms(id: number, body: { ids: number[] }): Observable<FieldManual[]> {
    return this.api.put(`${this.programsUrl}/${id}/fms`, body)
                   .map(() => {})
                   .publishReplay(1).refCount()
                   .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/field-manual.service.ts